/* ON:PACE KAZE 5 quality film.

   One MP4 that plays itself once when the section comes into view: the machine
   comes apart with a callout on each part (Phase One), then rebuilds and turns
   while phases 02 and 03 are typed in beside it. No scroll pin -- scrolling
   past, or back to it, costs the reader nothing.

   Everything the page draws over the film is keyed off the video's own FRAME,
   never a timer, so a pause, a replay or a viewer scrolling away mid-sentence
   all stay in sync. The per-frame callout anchors and the schedule live in the
   JSON asset, which is only fetched once the section is near.

   The section writes window.OPQF (sources + json url). Reduced motion, no JS
   and a browser that refuses to autoplay all fall back to the still frame with
   every phase and fact written out. */
(function () {
  var CFG = window.OPQF;
  var root = document.getElementById('qf');
  if (!CFG || !root) return;

  var box = document.getElementById('qf-box'),
      vid = document.getElementById('qf-vid'),
      still = document.getElementById('qf-still'),
      svg = document.getElementById('qf-lines'),
      phase = document.getElementById('qf-phases'),
      detail = document.getElementById('qf-detail'),
      replay = document.getElementById('qf-replay'),
      cos = [].slice.call(root.querySelectorAll('.qf-co')),
      phases = [].slice.call(root.querySelectorAll('.qf-ph')),
      dets = [].slice.call(root.querySelectorAll('.qf-det__item')),
      chks = [].slice.call(root.querySelectorAll('.qf-chk li')),
      cells = [].slice.call(root.querySelectorAll('.qf-batch i')),
      sums = [].slice.call(root.querySelectorAll('.qf-sum li')),
      /* phones draw the checklist and the batch on the picture, so there are
         two copies of each; index each one inside its own list rather than by
         position in the section */
      ovChk = root.querySelector('.qf-ov--chk'),
      ovBatch = root.querySelector('.qf-ov--batch'),
      grids = [].slice.call(root.querySelectorAll('.qf-batch'));

  function nth(el) { return [].indexOf.call(el.parentNode.children, el); }

  /* THE FOOT IS NOT INSIDE #qf. "See every test" and "Watch again" sit in
     .qf-foot, a SIBLING of the root, so a query scoped to the root finds
     neither of them -- which is why Watch again did nothing (Tris, 23 Sep).
     On the overlay path it had been quietly broken on every wide screen since
     the section shipped: the only replay button the root contains is the copy
     drawn on the picture, and that one is phone-only, so the handler always
     found something on a phone and never on a desktop. On a baked film the
     in-picture copy is not emitted at all, so nothing was bound anywhere.
     Everything else in here is legitimately inside the root; this is the one
     query that has to reach past it. */
  var band = (root.closest && root.closest('.op-shell')) || document;

  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  var narrow = window.matchMedia('(max-width: 640px)');
  var F = null, phone = narrow.matches, reduced = mq.matches,
      near = false, visible = false, t = 0,
      /* pin() places phase 03's text differently, and it is also called from
         layout() and resize where there is no frame to work it out from */
      livePhase = 1,
      deskBatch = root.querySelector('.qf-det .qf-batch');

  /* ================== BAKED FILMS (23 Sep 2026) ==================
     The KAZE 5 films cut on 23 Sep carry every graphic IN THE FRAMES -- the
     headline, the four callouts with their leader lines, phase 02's checklist,
     phase 03's serial and the end card. Everything below this function draws
     exactly those things over the video, so on this path none of it runs and
     the section does not even emit the markup for it. Pointing the overlay at
     a baked film would show every callout twice.

     What is left is three jobs: pick the cut that suits the viewport, play it
     once when it comes into view, and offer Watch again at the end. No frame
     loop, no per-frame anchors, and no fetch of the 150 KB schedule -- the
     section leaves its URL out of the config entirely.

     The whole of the reading detail is in the "See every test" pop-up, which
     the section still renders in both paths. It is now the only place that
     copy exists as text rather than as pixels, which is why it is not
     optional.

     RETURNS EARLY, so nothing under here is even wired up. The overlay path is
     byte-for-byte the code that has been live since 22 Sep. */
  if (CFG.baked) return bakedInit();

  function bakedInit() {
    /* The switch is the section's setting, not the 640 the two-column overlay
       layout needed -- with no columns to fit, the only question is which cut's
       own baked type reads at this width. See the section's schema. */
    /* the SAME query the section's inline style uses to cut the box, written
       the same way -- a min-width complement disagrees with it on a fractional
       viewport width, which is a box of one shape holding a film of the other */
    var narrowQ = window.matchMedia('(max-width:' + (CFG.switchPx || 800) + 'px)'),
        low = false, want = '';

    function src() { return (narrowQ.matches ? CFG.phone : CFG.desk) || {}; }

    /* ONE FILE, EVER. AV1 where the browser takes it -- same picture, about
       40% of the bytes -- and the H.264 cut otherwise; never both, and never
       the other viewport's. The <video> has preload="none", so assigning src
       costs nothing until play(). */
    function apply() {
      var s = src();
      if (!s.mp4) return;
      var w = (s.av1 && vid.canPlayType
               && vid.canPlayType('video/mp4; codecs="av01.0.05M.08"')) ? s.av1 : s.mp4;
      /* The poster goes up straight away and the box is cut to the film's own
         aspect in CSS, so the picture is there before a byte of video is and
         nothing reflows when it arrives. Same URL on the <img> and on the
         video's poster, so it is one request. */
      if (s.poster) { vid.poster = s.poster; if (still) still.src = s.poster; }
      if (!low || want === w) return;
      want = w;
      vid.src = w;
      vid.load();
    }

    function play() {
      if (mq.matches || !vid.src) return;
      var pr = vid.play();
      /* autoplay refused -- the button is the only way in, so offer it */
      if (pr && pr.catch) pr.catch(function () { offer(true); });
    }

    function mode() {
      var reduce = mq.matches;
      root.classList.toggle('is-play', !reduce);
      root.classList.toggle('is-still', reduce);
      apply();
      if (reduce) vid.pause();
    }

    /* Watch again appears when the film finishes and goes again while it is
       running, so the button is only there when pressing it means something.
       It is opacity-only in the stylesheet, so it also has to stop taking
       clicks and tab stops while it is invisible. */
    function offer(on) {
      if (!replay) return;
      replay.classList.toggle('is-on', on);
      replay.style.pointerEvents = on ? '' : 'none';
      if (on) replay.removeAttribute('tabindex'); else replay.setAttribute('tabindex', '-1');
    }
    offer(false);
    vid.addEventListener('ended', function () { offer(true); });
    vid.addEventListener('play', function () { offer(false); });
    [].forEach.call(band.querySelectorAll('[data-qf-replay]'), function (b) {
      b.addEventListener('click', function () { vid.currentTime = 0; play(); });
    });

    if (mq.addEventListener) mq.addEventListener('change', mode);
    if (narrowQ.addEventListener) narrowQ.addEventListener('change', mode);
    /* A viewport crossing the switch does not always fire the query's own
       change event -- the 22 Sep bug, where the section sat at 1100px playing
       the 4:5 cut. apply() is a no-op unless the file it wants has changed. */
    window.addEventListener('resize', apply);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (!e.isIntersecting) return; low = true; apply(); });
      }, { rootMargin: '200% 0px' }).observe(root);
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (mq.matches) return;
          if (e.isIntersecting) { if (vid.currentTime < (vid.duration || 1)) play(); } else vid.pause();
        });
      }, { threshold: 0.45 }).observe(box);
    } else { low = true; apply(); play(); }

    mode();
  }

  var ORDER = ['electrics', 'deck', 'motor', 'frame'];

  /* ---------- the ending ----------
     From F.cut on, the outro is CSS: one class on the root, and the beats are
     transition delays rather than frames, because there is no video clock left
     to share. The phone film STOPS at that frame, on a side-on profile; the
     desk film is a different render whose ending was signed off, so it plays on
     behind the merge and only the batch resolves (Tris, 22 Sep). The only thing
     script does is give each cell the offset that collapses the grid to its
     middle. */
  var outro = false;
  function setOutro(on) {
    if (on === outro) return;
    outro = on;
    root.classList.toggle('is-outro', on);
    if (!on) { cells.forEach(function (el) { el.style.transform = ''; }); return; }
    /* whichever copy of the batch is on screen -- the overlay on the picture on
       a phone, the one in the phase detail on desktop. The other measures zero */
    grids.forEach(function (grid) {
      var gr = grid.getBoundingClientRect();
      if (!gr.width) return;
      var cx = gr.left + gr.width / 2, cy = gr.top + gr.height / 2;
      [].forEach.call(grid.children, function (el) {
        var r = el.getBoundingClientRect();
        el.style.transform = 'translate(' + (cx - r.left - r.width / 2).toFixed(1) + 'px,'
          + (cy - r.top - r.height / 2).toFixed(1) + 'px)';
      });
    });
  }

  /* ---------- where the film sits inside the box ----------
     The picture is object-fit:contain, and on a phone the box is TALLER than
     the film: it carries a strip of Paper at the top for the headline and the
     film is anchored to the bottom of it. The callout anchors are normalised to
     the FILM, so they have to be mapped through the film's own rect -- taking
     them straight off the BOX put every dot 47-78px above the part it names,
     and the console's landed in the strip, off the machine altogether
     (Tris, 22 Sep: "the leader dots re-aimed so each lands properly on the part
     it names"). Desktop is a 16:10 film in a 16:10 box, so this returns the box
     and nothing up there changes. */
  function film() {
    var bw = box.clientWidth, bh = box.clientHeight,
        vw = vid.videoWidth, vh = vid.videoHeight;
    if (!vw || !vh) return { x: 0, y: 0, w: bw, h: bh };
    var k = Math.min(bw / vw, bh / vh), w = vw * k, h = vh * k;
    /* object-position: centre, and `center bottom` on a phone */
    return { x: (bw - w) / 2, y: phone ? bh - h : (bh - h) / 2, w: w, h: h };
  }

  function kind() { return phone ? 'phone' : 'desk'; }

  /* ---------- assets ---------- */
  function loadVideo() {
    var src = CFG[kind()];
    /* AV1 where the browser takes it: same picture, about 40% of the bytes. */
    var want = (vid.canPlayType && vid.canPlayType('video/mp4; codecs="av01.0.05M.08"'))
      ? src.av1 : src.mp4;
    if (vid.dataset.src !== want) {
      vid.dataset.src = want;
      vid.poster = src.poster;
      vid.src = want;
      vid.load();
    }
  }
  function wake() {
    if (near) return;
    near = true;
    still.src = CFG[kind()].poster;
    if (reduced) return;
    loadVideo();
    fetch(CFG.json).then(function (r) { return r.json(); }).then(function (data) {
      F = data;
      paint();
    }).catch(function () { still_(); });
  }
  function still_() { root.classList.remove('is-play'); root.classList.add('is-still'); }

  /* ---------- typing ---------- */
  function typeInto(el, win, f) {
    if (!el) return;
    var full = el.dataset.full;
    if (full === undefined) full = el.dataset.full = el.textContent;
    /* Phones do not type. The name and its line sit in reserved space ABOVE
       the picture there, so while they type themselves in that space is empty
       -- and the poster frame, which is what you look at before the film runs,
       is a heading over a hole (Tris, 21 Sep). On a wide screen the typing
       happens inside the picture beside the machine and costs nothing. */
    if (reduced || phone || !win) { el.textContent = full; el.classList.remove('qf-type'); return; }
    var k = (f - win[0]) / (win[1] - win[0]);
    if (k >= 1) { el.textContent = full; el.classList.remove('qf-type'); return; }
    if (k <= 0) { el.textContent = ''; el.classList.remove('qf-type'); return; }
    el.textContent = full.slice(0, Math.max(1, Math.round(full.length * k)));
    el.classList.add('qf-type');
  }
  function typePhase(n, f) {
    var spec = (F.type || {})[n] || {};
    typeInto(phases[n - 1].querySelector('strong'), spec.title, f);
    typeInto(dets[n - 1].querySelector('.qf-ph__sub'), spec.sub, f);
  }

  /* ---------- the frame-by-frame state ---------- */
  function paint() {
    if (!F || reduced) return;
    var N = F.frames, P1 = F.phase1,
        i = Math.round(t * (N - 1)),
        inP1 = i < P1, t1 = inP1 ? i / (P1 - 1) : 1, j = inP1 ? -1 : i - P1,
        ON = F.on, BACK = F.back, LBL = F.label_delay,
        GRID = F.grid, APPEAR = F.check_in, DONE = F.check_tick;

    var live = inP1 ? 1 : (j >= F.p3_in ? 3 : 2);
    livePhase = live;
    phases.forEach(function (el, n) {
      var num = n + 1,
          shown = num === 1 || (!inP1 && ((num === 2 && j >= F.p2_in) || (num === 3 && j >= F.p3_in)));
      el.classList.toggle('is-on', shown);
      el.classList.toggle('is-past', shown && num < live);
      var done = (num === 1 && !inP1) || (num === 2 && !inP1 && j >= F.p2_done)
              || (num === 3 && !inP1 && j >= F.p3_done);
      el.classList.toggle('is-done', done);
    });
    /* On desktop Phase One's description goes once the first callout lands, so
       it is not sitting in the picture beside them, and stays gone. On a phone
       it is the only prose above the picture, so it stays for the whole phase
       (Tris, 21 Sep). */
    dets[0].classList.toggle('is-on', inP1 && t1 < ON[ORDER[0]]);
    dets[1].classList.toggle('is-on', !inP1 && j >= F.p2_in && j < F.p3_in);
    dets[2].classList.toggle('is-on', !inP1 && j >= F.p3_in);

    var M = film(), out = '';
    /* The phone film is its own 4:5 render with its own camera, so it carries
       its own anchors; the desk set would point at nothing (21 Sep). */
    var ANC = (phone && F.anchors_phone) ? F.anchors_phone : F.anchors;
    cos.forEach(function (el) {
      var k = el.dataset.k,
          on = inP1 && t1 >= ON[k] && t1 < BACK + 0.03,
          a = ANC[k][Math.min(i, P1 - 1)];
      el.classList.toggle('is-on', on);
      el.classList.toggle('is-full', on && t1 >= ON[k] + LBL);
      if (!on) return;
      /* Phones get the same line and dot: the callout is on the picture there
         too now, just narrower (Tris, 21 Sep). The phone render shares the
         desktop framing, so the anchors need no remapping. */
      var left = el.dataset.side === 'l',
          br = box.getBoundingClientRect(),
          nr = el.querySelector('.qf-co__num').getBoundingClientRect(),
          er = el.getBoundingClientRect(),
          ax = M.x + a[0] * M.w, ay = M.y + a[1] * M.h,
          lx, ly;
      if (phone) {
        /* On a phone the callouts sit in bands above and below the machine, so
           the leader leaves the band-facing edge -- at the x NEAREST the part
           rather than under the figure, which is what turns three of the four
           into a straight drop onto the thing they name (Tris, 22 Sep). Clamped
           10px inside the block so it never leaves from a corner. */
        var top = (er.top + er.bottom) / 2 - br.top < box.clientHeight / 2;
        lx = Math.min(Math.max(ax, er.left - br.left + 10), er.right - br.left - 10);
        ly = (top ? er.bottom + 6 : er.top - 6) - br.top;
      } else {
        lx = (left ? er.right + 10 : er.left - 10) - br.left;
        ly = nr.top - br.top + nr.height / 2;
      }
      out += '<line x1="' + lx + '" y1="' + ly + '" x2="' + ax + '" y2="' + ay + '"/>'
           + '<circle cx="' + ax + '" cy="' + ay + '" r="' + (phone ? 4 : 4.5) + '"/>';
    });
    svg.innerHTML = out;

    chks.forEach(function (el) {
      var n = nth(el);
      el.classList.toggle('is-in', !inP1 && j >= APPEAR[n]);
      el.classList.toggle('is-done', !inP1 && j >= DONE[n]);
    });
    /* On a phone they are drawn on the picture. The panel comes up with the
       FIRST checkbox, not with the phase: from p2_in it stood there empty over
       the machine for ~2.7s before anything was in it (Tris, 22 Sep). */
    if (ovChk) ovChk.classList.toggle('is-on', phone && !inP1 && j >= APPEAR[0] && j < F.p3_in);
    /* On a phone the batch does not sit under the machine, it TAKES the
       picture: the grid comes up large and centred and the film fades back
       behind it, because the batch is what phase 03 is about (Tris, 22 Sep). */
    var onBatch = phone && !inP1 && j >= F.grid['in'] - 8;
    if (ovBatch) ovBatch.classList.toggle('is-on', onBatch);
    root.classList.toggle('is-batchview', !!onBatch);
    cells.forEach(function (el) {
      var n = nth(el), picked = n === 3 ? 0 : (n === 8 ? 1 : -1), on = !inP1;
      el.classList.toggle('is-in', on && j >= GRID['in'] + n * GRID.step);
      el.classList.toggle('is-pick', on && picked >= 0 && j >= GRID.picks[picked] && j < GRID.pass[picked]);
      el.classList.toggle('is-pass', on && picked >= 0 && j >= GRID.pass[picked] && j < GRID.batch);
      el.classList.toggle('is-batch', on && j >= GRID.batch + n * 2);
    });
    sums.forEach(function (el) {
      var k = el.dataset.k;
      el.classList.toggle('is-on', phone ? (!inP1 || t1 >= ON[k]) : (!inP1 || t1 >= BACK - 0.02));
    });
    typePhase(1, inP1 ? i : 1e6);
    typePhase(2, inP1 ? -1 : j);
    typePhase(3, inP1 ? -1 : j);
    /* with a cut the film never reaches t=1, so the foot's Watch again keys
       off the cut instead */
    replay.classList.toggle('is-on', t >= (CUTF ? CUTF - 0.002 : 0.995));
    pin();
  }

  /* the phase stack and the description sit IN the picture on desktop; the box
     is centred and its width follows the viewport, so both are measured */
  /* Where the phase detail sits, as fractions of the box. The column is the
     signed-off placement for phases 01 and 02, where the machine fills the
     frame. Phase 03's machine drops to y 0.247-0.934 and leaves the whole top
     quarter clear, so its text goes up there instead of into a 227px strip at
     the edge (Tris, 22 Sep). */
  var COL_L = 0.745, COL_W = 0.235,          // 0.98 - 0.235, kept exact
      BAND_L = 0.27, BAND_W = 0.46,          // right of the phase stack
      BAND_MIN = 780;                        // below this the band is too short

  function pin() {
    if (phone) {
      [phase, detail].forEach(function (el) { el.style.left = el.style.top = el.style.width = ''; el.style.position = ''; });
      if (deskBatch) deskBatch.style.position = deskBatch.style.left = deskBatch.style.top = deskBatch.style.width = deskBatch.style.marginTop = '';
      return;
    }
    var bw = box.clientWidth, w = bw * 0.225, top = box.offsetTop + box.clientHeight * 0.035;
    phase.style.position = detail.style.position = 'absolute';
    phase.style.width = w + 'px';
    phase.style.left = (box.offsetLeft + bw * 0.02) + 'px';
    phase.style.top = top + 'px';
    var band = livePhase === 3 && bw >= BAND_MIN,
        dl = bw * (band ? BAND_L : COL_L);
    detail.style.width = (bw * (band ? BAND_W : COL_W)) + 'px';
    detail.style.left = (box.offsetLeft + dl) + 'px';
    detail.style.top = top + 'px';
    /* The batch keeps the column whatever the text does, at the coordinates
       the column gave it, so its rect is unchanged. It is positioned out of
       the flow in every phase, not just phase 03, so there is one rule and the
       text above it can never push it. */
    if (deskBatch) {
      deskBatch.style.position = 'absolute';
      /* .qf-batch carries margin-top:12px, and margin still applies to an
         absolutely positioned box on top of `top` -- it landed 12px low */
      deskBatch.style.marginTop = '0';
      deskBatch.style.width = (bw * COL_W) + 'px';
      deskBatch.style.left = (bw * COL_L - dl) + 'px';
      deskBatch.style.top = (box.clientHeight * (
        /* 0.2199 = the batch's own top (156px) minus .qf-det's (21px) at the
           1100px width desktop was signed off at, over the box height (612).
           The column used to give it that position through the flow, which
           depended on how many lines the description and the closing line
           wrapped to -- and those change when the text moves to the band. A
           fraction of the box reproduces the signed-off geometry exactly at
           1100 and lands within 3px of it either side. */
        0.2199)) + 'px';
    }
  }

  /* ---------- playback ---------- */
  /* F.cut is where the ENDING begins, on both viewports. The phone film also
     stops there, on the side-on profile it happens to pass; the desk film is a
     different render whose ending is signed off, so it runs on to the end while
     its batch resolves beside it (Tris, 22 Sep). */
  var CUTF = 0, OUTF = 0;
  function outFrac() { return (F && F.cut) ? F.cut / (F.frames - 1) : 0; }
  function tick() {
    if (reduced) return;
    if (vid.duration) {
      t = Math.min(1, vid.currentTime / vid.duration);
      OUTF = outFrac();
      CUTF = phone ? OUTF : 0;
      if (CUTF && t >= CUTF) { t = CUTF; vid.pause(); }
      paint();
      setOutro(!!OUTF && t >= OUTF);
    }
    if (!vid.paused && !vid.ended) requestAnimationFrame(tick);
  }
  function start() {
    if (reduced || !vid.src) return;
    var p = vid.play();
    if (p && p.catch) p.catch(function () { replay.classList.add('is-on'); });
  }
  vid.addEventListener('play', function () { requestAnimationFrame(tick); });
  vid.addEventListener('ended', function () { t = 1; paint(); });
  vid.addEventListener('loadeddata', function () { t = vid.currentTime / (vid.duration || 1); paint(); });
  /* band, not root: the foot's button is outside #qf -- see the note up top.
     This is what gave the overlay path a dead Watch again on every wide
     screen, where the in-picture copy that was being bound is display:none. */
  [].forEach.call(band.querySelectorAll('[data-qf-replay]'), function (b) {
    b.addEventListener('click', function () {
      vid.currentTime = 0;
      sums.forEach(function (e) { e.classList.remove('is-on'); });
      setOutro(false);
      start();
    });
  });

  function layout() {
    phone = narrow.matches;
    reduced = mq.matches;
    root.classList.toggle('is-play', !reduced);
    root.classList.toggle('is-still', reduced);
    if (reduced) { vid.pause(); still.src = CFG[kind()].poster; pin(); return; }
    loadVideo();
    pin();
    paint();
  }
  if (mq.addEventListener) mq.addEventListener('change', layout);
  if (narrow.addEventListener) narrow.addEventListener('change', layout);
  /* A resize that crosses 640 without the media query's change event firing
     would leave the other viewport's film playing -- loadVideo() is a no-op
     unless the source it wants has actually changed. */
  window.addEventListener('resize', function () {
    phone = narrow.matches;
    if (!reduced) loadVideo();
    pin();
    paint();
  });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) wake(); });
    }, { rootMargin: '200% 0px' }).observe(root);
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        visible = e.isIntersecting;
        if (reduced) return;
        if (visible) { if (vid.currentTime < (vid.duration || 1)) start(); } else vid.pause();
      });
    }, { threshold: 0.45 }).observe(box);
  } else { wake(); visible = true; start(); }

  layout();
})();
